import { useCallback, useContext, useEffect, useMemo, useState } from "react";

import { Grid } from "@material-ui/core";

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import AccordionFornecedorGeral from "./children/AccordionFornecedorGeral";
import AccordionFornecedorContato from "./children/AccordionFornecedorContato";
import AccordionFornecedorBanco from "./children/AccordionFornecedorBanco";
import AccordionFornecedorAdicionais from "./children/AccordionFornecedorAdicionais";
import AccordionFonecedorIntegracao from "./children/AccordionFornecedorIntegracao";
import Btn from "../../../components/buttons/Btn";
import { findClassificacoesfornecedores } from "../../../repository/ERP/prouser/ClassificacaoFornecedorService";
import { findFornecedor } from "../../../repository/ERP/prouser/FornecedorService";
import { findBancos } from "../../../repositories/qerpapi/v3/BancosRepository";
import { findFornecedorServicos } from "../../../repository/admQERP/public/FornecedorServicos";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import MaskService from "../../../utils/mask/maskService";
import { formatDate } from "../../../utils/formatDate";
import { PainelContainer } from "./styles/Fornecedor";
import useFornecedorController from "./controllers/FornecedorController";
import { FornecedorContext } from "./contexts/FornecedorContext";
import AccordionRuralEstablishment from "./children/AccordionRuralEstablishment";
import { validarCNPJ, validarCPF } from "../../../utils/validations";
import { GlobalVariables } from "../../../GlobalVariables";

let temporizer = null;
const FornecedoresCadstro = ({ location }) => {
  const { handleSubmit, handleBackSubmit, clear, handleNumInscricao } =
    useFornecedorController();

  const { queryParams } = useContext(QueryParamsContext);

  const {
    setListBank,
    listCounty,
    listNation,
    listClassifiction,
    setListClassifiction,
    listUf,
    setLoadingInputs,
    loading,
    setLoading,
    setGeralCustomerId,
    setGeralCpfCnpj,
    setGeralRazao,
    setGeralFantasia,
    setGeralCEP,
    setGeralEndereco,
    setGeralNumero,
    setGeralComplemento,
    setGeralBairro,
    setGeralEstado,
    setGeralMunicipio,
    setGeralPais,
    setGeralDdd,
    setGeralTel,
    setGeralEmail,
    setGeralIe,
    setGeralSm,
    setGeralCf,
    setGeralIm,
    setGeralTipoInscricao,
    setGeralAtivo,
    setProviderType,
    setIntegrationConectionCod,
    setIntegrationDueDate,
    setIntegrationCpfCnpj,
    setIntegrationDescription,
    setGeralCelular,
    setGeralWhatsappAtivo,
    ruralProducer,
    setRuralProducer,
    setValidCpfCnpj,

    setPrevisao,
    setClassificacao,
    setGrupoEconomico,
    setObservacao,

    setRuralEstablishment,

    setContacts,
    setBank,
    optionsFilterProvider,
    setOptionsFilterProvider,
    IeIndicationList,
    setIeIndication,
  } = useContext(FornecedorContext);
  const [dataSupplierEdit, setDataSupplierEdit] = useState({});

  const listOptions = useMemo(
    () => [
      {
        label: "SIM",
        id: "S",
      },
      {
        label: "NÃO",
        id: "N",
      },
    ],
    []
  );

  useEffect(() => {
    clear();
  }, [clear]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listClassifiction: true,
        }));
        const resulClassifiction = await findClassificacoesfornecedores(
          queryParams.empresa_cnpj,
          1000
        );
        if (resulClassifiction.success)
          setListClassifiction(resulClassifiction.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listClassifiction: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListClassifiction, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listBank: true,
        }));

        const resultBank = await findBancos();

        if (resultBank.success) setListBank(resultBank.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listBank: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListBank, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          optionsFilterProvider: true,
        }));

        const resultFornecedor = await findFornecedorServicos();

        if (resultFornecedor.success && resultFornecedor.data)
          setOptionsFilterProvider(resultFornecedor.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          optionsFilterProvider: false,
        }));
      }
    })();
  }, [setLoadingInputs, setOptionsFilterProvider]);

  useEffect(() => {
    if (!location?.state?.item?.id) return;
    setGeralCustomerId(location.state.item.id || null);

    (async () => {
      try {
        setLoading(true);

        const dataCustomer = await findFornecedor(
          queryParams.empresa_cnpj,
          location.state.item.id,
          "contatos,contasbancarias,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos",
          "estabelecimentosRurais,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco"
        );

        if (!dataCustomer.success && !dataCustomer.data) return;

        const data = dataCustomer.data;
        setDataSupplierEdit(data);

        if (data.cgc) {
          const cpfOrCnpj =
            data.cgc.replace(/[^0-9]+/g, "").length === 11 ? "cpf" : "cnpj";

          if (cpfOrCnpj === "cpf") {
            setValidCpfCnpj(validarCPF(data?.cgc || ""));
          } else {
            setValidCpfCnpj(validarCNPJ(data?.cgc || ""));
          }

          setGeralTipoInscricao(
            data.cgc.replace(/[^0-9]+/g, "").length > 11
              ? { descricao: "CNPJ" }
              : { description: "CPF" }
          );

          setGeralCpfCnpj(MaskService.toMask(cpfOrCnpj, data.cgc || ""));
        }

        setGeralCustomerId(data.id || "");
        setGeralCelular(data.celular || "");
        setGeralWhatsappAtivo(data.whatsapp_ativo === 1);
        setGeralFantasia(data.apelido.substring(0, 20) || "");
        setGeralRazao(data.razao.substring(0, 50) || "");
        setGeralCEP(MaskService.toMask("cep", data.cep || ""));
        setGeralEndereco(data.endereco || "");
        setGeralNumero(data.numero || "");
        setGeralBairro(data.bairro || "");
        setGeralTel(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd1 || ""}${data.telefone1 || ""}`
          )
        );
        setGeralDdd(data.ddd1);
        setGeralEmail(data.email1 || "");
        setGeralIe(data.ie || "");
        setGeralComplemento(data.complemento || "");
        setGeralSm(data.simples_nacional === "S");
        setGeralCf(data.consumidorfinal === "0");
        setGeralAtivo(data.ativo === "S");
        setGeralIm(data.inscricao_municipal || "");
        setPrevisao(data.previsaoentrega || "");
        setObservacao(data.observacao || "");
        setGrupoEconomico(data.cnpjmatriz || "");
        setContacts(data.contatos || []);
        setBank(data.contasbancarias || []);
        setIntegrationDueDate(
          formatDate({
            date: data.ultimo_vencimento,
            separator: "-",
            format: "yyyy-mm-dd",
          }) ||
            formatDate({
              date: new Date(),
              separator: "-",
              format: "yyyy-mm-dd",
            })
        );
        setIntegrationConectionCod(data.codigo_ligacao || "");
        const cpfCnpjServico = data.cpfcnpjservico
          ? data.cpfcnpjservico
          : queryParams.empresa_cnpj;
        setIntegrationCpfCnpj(
          MaskService.toMask(
            cpfCnpjServico.length > 12 ? "cnpj" : "cpf",
            cpfCnpjServico
          )
        );
        setIntegrationDescription(data.descricaoservico);
        setRuralProducer(!!data.produtor_rural);

        // Estabelecimentos
        const estabelecimentosRurais = (data.estabelecimentos_rurais || []).map(
          (estabelecimento) => {
            const contacts =
              Array.isArray(estabelecimento.contatos) &&
              estabelecimento.contatos[0]
                ? estabelecimento.contatos[0]
                : null;

            return {
              ...estabelecimento,
              contatos: [
                {
                  principal: contacts?.pivot?.principal || 0,
                  infoContato: {
                    id: contacts?.id || null,
                    nome: contacts?.nome || "",
                    telefone: contacts?.telefone || "",
                  },
                },
              ],
            };
          }
        );

        setRuralEstablishment(estabelecimentosRurais);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    queryParams.empresa_cnpj,
    location.state,
    setBank,
    setContacts,
    setGeralAtivo,
    setGeralBairro,
    setGeralCEP,
    setGeralCelular,
    setGeralCf,
    setGeralComplemento,
    setGeralCpfCnpj,
    setGeralCustomerId,
    setGeralDdd,
    setGeralEmail,
    setGeralEndereco,
    setGeralFantasia,
    setGeralIe,
    setGeralIm,
    setGeralNumero,
    setGeralRazao,
    setGeralSm,
    setGeralTel,
    setGeralTipoInscricao,
    setGeralWhatsappAtivo,
    setGrupoEconomico,
    setIntegrationConectionCod,
    setIntegrationCpfCnpj,
    setIntegrationDescription,
    setIntegrationDueDate,
    setLoading,
    setObservacao,
    setPrevisao,
    setRuralProducer,
    setRuralEstablishment,
    setValidCpfCnpj,
  ]);

  useEffect(() => {
    if (!dataSupplierEdit.municipio_codigo) {
      return;
    }

    setGeralMunicipio(
      listCounty.find(
        (opt) => opt.codigo === dataSupplierEdit.municipio_codigo
      ) || null
    );
  }, [dataSupplierEdit, listCounty, setGeralMunicipio]);

  useEffect(() => {
    if (!dataSupplierEdit.id_estado) {
      return;
    }

    setGeralEstado(
      listUf.find((opt) => opt.id === dataSupplierEdit.id_estado) || null
    );
  }, [dataSupplierEdit, listUf, setGeralEstado]);

  useEffect(() => {
    if (!dataSupplierEdit.simples_nacional) {
      return;
    }

    setGeralSm(
      listOptions.find((opt) => opt.id === dataSupplierEdit.simples_nacional) ||
        null
    );
  }, [dataSupplierEdit, setGeralSm, listOptions]);

  useEffect(() => {
    if (!dataSupplierEdit.idclassificacao) {
      return;
    }

    setClassificacao(
      listClassifiction.find(
        (opt) => opt.id === dataSupplierEdit.idclassificacao
      ) || null
    );
  }, [dataSupplierEdit, listClassifiction, setClassificacao]);

  useEffect(() => {
    if (!dataSupplierEdit.idpais) {
      return;
    }

    setGeralPais(
      listNation.find((opt) => opt.codigo === dataSupplierEdit.idpais) || null
    );
  }, [dataSupplierEdit, listNation, setGeralPais]);

  useEffect(() => {
    if (!dataSupplierEdit.indiedest) {
      return;
    }

    setIeIndication(
      IeIndicationList.find(
        (opt) => opt.value === parseInt(dataSupplierEdit.indiedest)
      ) || null
    );
  }, [dataSupplierEdit, IeIndicationList, setIeIndication]);

  useEffect(() => {
    if (!dataSupplierEdit.id_fornecedor_servico) {
      return;
    }

    setProviderType(
      optionsFilterProvider.find(
        (opt) => opt.id === dataSupplierEdit.id_fornecedor_servico
      ) || {
        descricao: "Nenhum",
        id: 1,
      }
    );
  }, [dataSupplierEdit, optionsFilterProvider, setProviderType]);

  const getConditions = useCallback(
    () => ({
      showCondition: {
        contatos: queryParams.guia_fornecedores_contatos === "1",
        infosFinanceiras:
          queryParams.guia_fornecedores_infosfinanceiras === "1",
        integracoes: queryParams.guia_fornecedores_integracoes === "1",
        outrasInfos: queryParams.guia_fornecedores_outrasinfos === "1",
      },
    }),
    [
      queryParams.guia_fornecedores_contatos,
      queryParams.guia_fornecedores_infosfinanceiras,
      queryParams.guia_fornecedores_integracoes,
      queryParams.guia_fornecedores_outrasinfos,
    ]
  );

  const { showCondition } = getConditions();

  useEffect(() => {
    if (!queryParams?.cpfcnpj) return;
    let newInput = queryParams?.cpfcnpj;
    let mask;
    let updatedInput = newInput;

    if (newInput.length === 14) {
      mask = "cnpj";
      updatedInput = MaskService.toMask(mask, newInput);
    } else if (newInput.length === 11) {
      mask = "cpf";
      updatedInput = MaskService.toMask(mask, newInput);
    }
    setGeralCpfCnpj(updatedInput);

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleNumInscricao(updatedInput);
    }, 1800);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams.cpfcnpj]);

  return (
    <>
      <HeaderModule
        title="CADASTRO DE FORNECEDORES"
        textcolor="black"
        videoId={GlobalVariables.screenVideosIds.cadastroFornecedor}
      />

      <Loading open={loading} />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item>
            <AccordionFornecedorGeral />
          </Grid>
          <Grid item xs={12}>
            {ruralProducer && <AccordionRuralEstablishment />}
          </Grid>
          <Grid item xs={12}>
            {showCondition.contatos && <AccordionFornecedorContato />}
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            {showCondition.infosFinanceiras && <AccordionFornecedorBanco />}
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            {showCondition.outrasInfos && <AccordionFornecedorAdicionais />}
          </Grid>
          <Grid item xs={12}>
            {showCondition.integracoes && <AccordionFonecedorIntegracao />}
          </Grid>
        </Grid>
        <Grid
          item
          container
          justify="flex-end"
          style={{ marginTop: 20, marginBottom: 20 }}
          spacing={1}
        >
          <Grid item>
            <Btn label="Voltar" bgcolor="tertiary" onClick={handleBackSubmit} />
          </Grid>
          {(!location?.state?.item?.id || location.state.item.id !== 1) && (
            <>
              <Grid item>
                <Btn label="Salvar" onClick={() => handleSubmit(false)} />
              </Grid>
              <Grid item>
                <Btn label="Salvar e Novo" onClick={() => handleSubmit(true)} />
              </Grid>
            </>
          )}
        </Grid>
      </PainelContainer>
    </>
  );
};

export default FornecedoresCadstro;
